module.exports = __webpack_public_path__ + "static/img/Langford.964eba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Langford.jpg
// module id = WQTZ
// module chunks = 0